// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner-container__W0Klaxj9{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.spinner-container__W0Klaxj9 .spinner__Y2RZj_ao{height:30px;width:30px}.player-iframe-container__cRpOpWvX{height:90%;margin-top:10px;position:relative;width:100%}.player-iframe-container__cRpOpWvX .player-iframe-overlay__Ma8M4nIb{cursor:pointer;height:100%;left:0;position:absolute;top:0;width:100%;z-index:1}.player-iframe-container__cRpOpWvX .player-iframe__bFbmZ5Xo{border:1px solid var(--component-outline-color);border-radius:6px;height:100%;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinnerContainer": "spinner-container__W0Klaxj9",
	"spinner": "spinner__Y2RZj_ao",
	"playerIframeContainer": "player-iframe-container__cRpOpWvX",
	"playerIframeOverlay": "player-iframe-overlay__Ma8M4nIb",
	"playerIframe": "player-iframe__bFbmZ5Xo"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
